// Spread onto every Amplitude event by the plugin in `main.js`, so no track call has to carry
// them. The two that are not known when the app loads are filled in as the scan runs.
export const amplitudeCommonProperties = {
  scanApp: undefined,
  sessionId: undefined,
  scanningURL: window.location.href,
  attemptId: 0
}
